import { render } from "./VolumeDiskOfferingSelectView.vue?vue&type=template&id=3c7d01df&scoped=true"
import script from "./VolumeDiskOfferingSelectView.vue?vue&type=script&lang=js"
export * from "./VolumeDiskOfferingSelectView.vue?vue&type=script&lang=js"

import "./VolumeDiskOfferingSelectView.vue?vue&type=style&index=0&id=3c7d01df&lang=less&scoped=true"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c7d01df"]])

export default __exports__